const Environment = {
  DEVELOPMENT: 'DEVELOPMENT',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION',
};

const envByAppEnv = {
  development: Environment.DEVELOPMENT,
  staging: Environment.STAGING,
  production: Environment.PRODUCTION,
};

const env = envByAppEnv[window.system2.appEnv] || Environment.PRODUCTION;

const isDev = env === Environment.DEVELOPMENT;

const isStaging = env === Environment.STAGING;

const isTestRun = !!window.system2.isTestRun;

export {
  Environment,
  env,
  isDev,
  isStaging,
  isTestRun,
};
